module.exports = __webpack_public_path__ + "static/media/radio-active.a26326d4.svg";